import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router, UrlTree } from '@angular/router';
import { AuthStateService } from '../auth/auth-state.service';

/**
 * Dedicated Terms editor page — Irish Taylor staff admins only.
 *
 * Not gated by showTerms: staff must reach this page to turn Terms on/off for
 * customers. Public `/legal/terms` stays gated separately.
 *
 * Layered: canMatch + canActivate + in-component check.
 */
export function isTermsEditorAllowed(auth: AuthStateService): boolean {
  if (!auth.isAuthenticated()) {
    return false;
  }
  if (!auth.isITStaff()) {
    return false;
  }
  return (auth.userRole() || '').toLowerCase() === 'admin';
}

function deny(auth: AuthStateService, router: Router): boolean | UrlTree {
  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }
  return router.createUrlTree(['/app/smartfreight/rates']);
}

export const termsEditorCanMatch: CanMatchFn = () => {
  const auth = inject(AuthStateService);
  const router = inject(Router);
  if (isTermsEditorAllowed(auth)) {
    return true;
  }
  return deny(auth, router);
};

export const termsEditorGuard: CanActivateFn = () => {
  const auth = inject(AuthStateService);
  const router = inject(Router);
  if (isTermsEditorAllowed(auth)) {
    return true;
  }
  return deny(auth, router);
};
